import React, { Component } from "react";

import Section from "../components/Section";

class ProjectsSection extends Component {
  render() {
    return (
      <Section id="projects" className="projects-section">
        <div>Project Section</div>
      </Section>
    );
  }
}

export default ProjectsSection;
